import api from "Common/Client/Interceptor";

const getLearnersByManager = async (managerId, token, { pageNumber = 1, pageSize = 10, orderByLatest = false } = {}) => {
  try {
    const response = await api.get(
      `/Learners/GetList-For-Performance-Review?managerId=${managerId}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderByLatest=${orderByLatest}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default {
  getLearnersByManager,
};
